import { Tooltip, theme } from 'antd'
import dayjs from 'dayjs'
import { FC } from 'react'
import Shipment from '../../../../../types/api/shipment'
import { getPrintEndTime } from '../../helpers/get-print-end-time'

interface PrintEndTimeCellProps {
    shipment?: Shipment
}

const PrintEndTimeCell: FC<PrintEndTimeCellProps> = ({ shipment }) => {
    const { token } = theme.useToken()
    const printEndTime = getPrintEndTime(shipment)

    if (!printEndTime) return <>—</>

    const formatted = dayjs(printEndTime.endAt).format('DD.MM HH:mm')

    if (!printEndTime.isEstimate) return <span>{formatted}</span>

    return (
        <Tooltip title='Ориентировочно: начало печати + расчётное время печати'>
            <span style={{ color: token.colorWarningText }}>{formatted}</span>
        </Tooltip>
    )
}

export default PrintEndTimeCell
